import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-md'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center">
            <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="flex items-center space-x-2 md:space-x-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_settle-de/artifacts/ei2t4zd1_20251110_GRP%20black_Private%20investments.jpg" 
                alt="GR Prosperity Logo" 
                className="h-8 w-8 md:h-10 md:w-10 object-contain"
                style={{ mixBlendMode: 'multiply' }}
              />
              <div className="flex items-center space-x-1.5 md:space-x-2">
                <span className="text-base md:text-xl font-bold text-gray-900">GR. PROSPERITY</span>
              </div>
              <div className="w-px h-5 md:h-6 bg-gray-300"></div>
              <span className="text-base md:text-xl font-bold text-orange-500">Expats</span>
            </button>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-6 xl:space-x-8">
            <button
              onClick={() => scrollToSection('services')}
              className="text-sm xl:text-base text-gray-700 hover:text-orange-500 font-medium transition-colors whitespace-nowrap"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('hr-section')}
              className="text-sm xl:text-base text-gray-700 hover:text-orange-500 font-medium transition-colors whitespace-nowrap"
            >
              For Companies
            </button>
            <button
              onClick={() => scrollToSection('process')}
              className="text-sm xl:text-base text-gray-700 hover:text-orange-500 font-medium transition-colors whitespace-nowrap"
            >
              Process
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="text-sm xl:text-base text-gray-700 hover:text-orange-500 font-medium transition-colors whitespace-nowrap"
            >
              FAQ
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-orange-500 hover:bg-orange-600 text-white transition-colors text-sm xl:text-base"
            >
              Get Started
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-900 hover:text-orange-500 transition-colors"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-4 bg-white/95 backdrop-blur-md rounded-b-lg shadow-lg">
            <div className="flex flex-col space-y-4 px-4">
              <button
                onClick={() => scrollToSection('services')}
                className="text-gray-700 hover:text-orange-500 font-medium text-left transition-colors"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('hr-section')}
                className="text-gray-700 hover:text-orange-500 font-medium text-left transition-colors"
              >
                For Companies
              </button>
              <button
                onClick={() => scrollToSection('process')}
                className="text-gray-700 hover:text-orange-500 font-medium text-left transition-colors"
              >
                Process
              </button>
              <button
                onClick={() => scrollToSection('faq')}
                className="text-gray-700 hover:text-orange-500 font-medium text-left transition-colors"
              >
                FAQ
              </button>
              <Button
                onClick={() => scrollToSection('contact')}
                className="bg-orange-500 hover:bg-orange-600 text-white w-full transition-colors"
              >
                Get Started
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
